import { connectToTrainer, connectToHeartRateMonitor } from '../lib/bluetooth';
import { CadenceConfig } from './CadenceConfig';

interface BluetoothConnectorProps {
  connected: boolean;
  setConnected: React.Dispatch<React.SetStateAction<boolean>>;
  hrConnected: boolean;
  setHrConnected: React.Dispatch<React.SetStateAction<boolean>>;
  cadenceEnabled: boolean;
  setCadenceEnabled: React.Dispatch<React.SetStateAction<boolean>>;
}

export function BluetoothConnector({
  connected,
  setConnected,
  hrConnected,
  setHrConnected,
  setCadenceEnabled,
}: BluetoothConnectorProps) {
  async function handleConnectTrainer() {
    try {
      await connectToTrainer();
      setConnected(true);
    } catch (e) {
      alert('Trainer connection failed: ' + (e as Error).message);
    }
  }

  async function handleConnectHeartRate() {
    try {
      await connectToHeartRateMonitor();
      setHrConnected(true);
    } catch (e) {
      alert('Heart rate monitor connection failed: ' + (e as Error).message);
    }
  }

  return (
    <div className="mb-4 space-y-3">
      <div className="flex flex-col sm:flex-row gap-2">
        <button
          onClick={handleConnectTrainer}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 flex-1"
        >
          {connected ? 'Trainer Connected ✅' : 'Connect Trainer'}
        </button>
        <button
          onClick={handleConnectHeartRate}
          className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 flex-1"
        >
          {hrConnected
            ? 'Heart Rate Connected ❤️'
            : 'Connect Heart Rate Monitor'}
        </button>
        <div className="flex-1">
          <CadenceConfig onCadenceConnectionChange={setCadenceEnabled} />
        </div>
      </div>

      {!connected && (
        <p className="text-sm text-orange-600">
          ⚠️ Trainer connection required to start workout
        </p>
      )}
    </div>
  );
}
